<template>
  <div
    :data-input-for="name || label"
    class="input-field"
    :class="{ 'has-error': !!errorMessage, success: (meta && meta.valid) }"
  >
    <label v-if="label" :class="placeholder ? 'sr-only' : ''">
      {{ label }}
    </label>
    <slot />
    <p class="help-message" v-show="errorMessage || (meta && meta.valid)">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: Boolean,
      required: true,
      default: false,
    },
    errorMessage: {
      type: String,
    },
    meta: {
      type: Object
    }
  },
  setup() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
$primary-color: #0071fe;
$error-color: #f23648;
$error-bg-color: #fddfe2;

label {
  padding-right: 1em;
}

input:focus {
  border-color: $primary-color;
}

.help-message {
  margin: 0;
  font-size: 14px;
}

.input-field.has-error {
  /deep/ input,
  /deep/ select {
    background-color: $error-bg-color;
    color: $error-color;
  }
}

.input.has-error input:focus {
  border-color: $error-color;
}

.input-field.has-error .help-message {
  color: $error-color;
}
</style>
